/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DtoCreateMediaFromCloudRequest } from '../../models/dto-create-media-from-cloud-request';
import { TravelDraftMinimal } from '../../models/travel-draft-minimal';

export interface TravelControllerAddCountryPictureFromCloud$Params {
  id: number;
      body: DtoCreateMediaFromCloudRequest
}

export function travelControllerAddCountryPictureFromCloud(http: HttpClient, rootUrl: string, params: TravelControllerAddCountryPictureFromCloud$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelDraftMinimal;
}>> {
  const rb = new RequestBuilder(rootUrl, travelControllerAddCountryPictureFromCloud.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TravelDraftMinimal;
      }>;
    })
  );
}

travelControllerAddCountryPictureFromCloud.PATH = '/travel/{id}/picture-from-cloud';
